/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_PullupInputs */

const en_platform_plan_pullup = /** @type {(inputs: Platform_Plan_PullupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pull-up`)
};

const pl_platform_plan_pullup = /** @type {(inputs: Platform_Plan_PullupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podciąganie`)
};

/**
* | output |
* | --- |
* | "Pull-up" |
*
* @param {Platform_Plan_PullupInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_pullup = /** @type {((inputs?: Platform_Plan_PullupInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_PullupInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_pullup(inputs)
	return en_platform_plan_pullup(inputs)
});